import React, { useEffect, useState } from 'react';
// import Edit from '../../../../../Assets/Lens/EditLens.svg';
import Delete from '../../../../../Assets/Lens/deleteLens.svg';
import Hide from '../../../../../Assets/Lens/hide.svg';
import View from '../../../../../Assets/Lens/View.svg';
// import Flag from '../../../../../Assets/Lens/flag.svg';
import User from '../../../../../Assets/Lens/user.svg';
import { checkCommentingOnPost, checkFollowing, followSeller, toggleCommentingOnPost, unfollowSeller } from '../../../../../lib/utils/apiCalls';
import { setModal, setSelectedPost } from '../../../../../Features/lensSlice';
import { useDispatch, useSelector } from 'react-redux';

function KebabMenu({ kebabOpen, user, post, handleKebab, boxRef, commentAllowed, handleCommentAllowed }) {
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);
    const [following, setFollowing] = useState(false);

    const storeData = useSelector((state) => state.lens.storeData.storeData);
    const sellerInfo = useSelector((state) => state.lens.sellerInfo.sellerInfo);

    const handleToggleFollow = async () => {
        const userId = post.SellerUserId || post.UserId;

        if(following) {
            try {
                await unfollowSeller(userId);
            }
            catch(err) {
                console.log(err);
            }
        }
        else {
            try {
                await followSeller(userId);
            }
            catch(err) {
                console.log(err);
            }
        }

        try {
            const response = await checkFollowing(userId);
            setFollowing(response);
        }
        catch(err) {
            console.log(err);
        }
    }

    const handleDeletePost = async () => {
        dispatch(setModal('delete'));
        dispatch(setSelectedPost(post));
    }

    // const handleReportButton = () => {
    //     dispatch(setModal('report-post'));
    // }

    useEffect(() => {
        if(kebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [kebabOpen]);

    const handleHideComments = async () => {
        let postId = post.id;
        const callData = {
            postId,
            commentAllow: !commentAllowed,
        }
        try {
            await toggleCommentingOnPost(callData);
            const response = await checkCommentingOnPost(post.id);
            handleCommentAllowed(response);
        }
        catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        const userId = post.SellerUserId || post.UserId;

        const checkIfFollowing = async () => {
            if(userId !== storeData.id) {
                try {
                    const response = await checkFollowing(userId);
                    setFollowing(response);
                }
                catch(err) {
                    console.log(err);
                }
            }
        }

        Object.keys(post).length > 0 && checkIfFollowing();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post]);

    // const handleEditPost = () => {
    //     handleKebab();
    // }

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out absolute w-[238px] px-2 py-1 rounded-md bg-[#FFFFFF] top-0 right-6 shadow-[0px_0px_12px_0px_#0000003D]`}>
            {
                (storeData.id === sellerInfo.id) ?
                <>
                    {/* <button onClick={handleEditPost} className='w-full flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={Edit} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit</p>
                    </button> */}

                    <button onClick={handleDeletePost} className='w-full flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={Delete} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
                    </button>

                    <button onClick={handleHideComments} className='w-full flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={commentAllowed ? Hide : View} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>
                            Turn {commentAllowed ? 'off' : 'on'} Comments
                        </p>
                    </button>
                </> : 
                <>
                    <button onClick={handleToggleFollow} className='w-full select-none flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={User} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>{following ? 'Unfollow' : 'Follow'} {post.UserId ? user.fullName : user.name}</p>
                    </button>

                    {/* <button onClick={handleReportButton} className='w-full select-none flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={Flag} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>Report this Post</p>
                    </button> */}
                </>
            }
        </div>
    );
}

export default KebabMenu;
